var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });
